import classNames from "classnames";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useOnScroll } from "shared/hooks/useOnScroll";
import SekeletonLoader from "shared/loaders/skeleton";
import {
  GetNotificationsService,
  ReadAllNotificationsService,
} from "shared/services/notifications";
import styles from "./style.module.scss";
import NoContentCard from "shared/components/common/noContentCard";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";
import GlobalWrapper from "shared/components/common/globalWrapper";

interface NotificationDropDownProps {
  show: boolean;
  setShow: (val: boolean) => void;
  count: number;
  setCount: (val: number) => void;
}

const NotificationsDropDown = ({
  show,
  setShow,
  count,
  setCount,
}: NotificationDropDownProps) => {
  const navigate = useNavigate();
  const [endReach, onScroll] = useOnScroll("notifications-list-container");

  const pageRef = useRef<number>(1);
  const notificaionsRef = useRef<any[]>([]);

  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [moreLoad, setMoreLoad] = useState<boolean>(true);

  const handleGetNotificationsList = () => {
    setLoading(true);
    GetNotificationsService({ pageNo: pageRef.current })
      .then(({ data: { data, last_page, current_page }, status }) => {
        if (status) {
          let temp = [...notificaionsRef.current, ...data];
          setNotifications(temp);
          notificaionsRef.current = temp;
          if (current_page === last_page) {
            setMoreLoad(false);
          } else {
            setMoreLoad(true);
          }
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const handleReadAllNotifications = () => {
    ReadAllNotificationsService()
      .then(() => {
        setCount(0);
      })
      .catch((err) => {});
  };

  function handleClick(e: any) {
    const elem: any = document.getElementById("notificationsDropDownContainer");
    if (elem) {
      if (!elem?.contains(e.target)) {
        setShow?.(false);
      }
    }
  }

  useEffect(() => {
    if (endReach && !loading && moreLoad) {
      pageRef.current++;
      setLoading(true);
      handleGetNotificationsList();
    }
    // eslint-disable-next-line
  }, [endReach]);

  useEffect(() => {
    if (show) {
      pageRef.current = 1;
      notificaionsRef.current = [];
      setNotifications([]);
      handleGetNotificationsList();
      setTimeout(() => {
        handleReadAllNotifications();
      }, 1000);
    }
    // eslint-disable-next-line
  }, [show]);

  useEffect(() => {
    document.body.addEventListener(
      "click",
      (event: any) => {
        handleClick(event);
      },
      true
    );

    return () => {
      document.body.removeEventListener(
        "click",
        (event: any) => {
          handleClick(event);
        },
        true
      );
    };
    // eslint-disable-next-line
  }, []);

  return (
    <GlobalWrapper>
      <div
        className={classNames(styles.optionsContainer)}
        id={"notificationsDropDownContainer"}
        style={show ? { display: "flex" } : { display: "none" }}
      >
        <div className={classNames(styles.titleContainer, "py-3 px-3")}>
          <h1>Notifications</h1>
          {count ? <span>{count}</span> : null}
        </div>

        <div
          className={classNames(styles.listContainer, "py-3")}
          id="notifications-list-container"
          onScroll={onScroll}
        >
          {loading ? (
            <>
              {Array.from(Array(2).keys()).map((itm, inx) => {
                return (
                  <div
                    className={classNames(
                      styles.notificationContainer,
                      "px-3 py-3 gap-2 w-full"
                    )}
                    key={inx}
                  >
                    <SekeletonLoader className={classNames(styles.imgLoader)} />
                    <div className={classNames("flex flex-col gap-2")}>
                      <SekeletonLoader
                        className={classNames(styles.headLineLoader)}
                      />
                      <div className={classNames("flex flex-col gap-1 w-full")}>
                        <SekeletonLoader
                          className={classNames(styles.descLineLoader, "w-3/4")}
                        />
                        <SekeletonLoader
                          className={classNames(styles.descLineLoader, "w-1/2")}
                        />
                      </div>
                      <SekeletonLoader
                        className={classNames(styles.timeLineLoader)}
                      />
                    </div>
                  </div>
                );
              })}
            </>
          ) : notifications?.length > 0 ? (
            <>
              {notifications?.map((itm, inx) => {
                return (
                  <div
                    className={classNames(
                      styles.notificationContainer,
                      "px-3 py-3 gap-2"
                    )}
                    key={inx}
                    onClick={() => {
                      setShow(false);
                      navigate(routeConstant.requestedEvaluation.path);
                    }}
                  >
                    <div className={classNames(styles.avtTitle)}>
                      <label>
                        {itm?.organization?.name[0]}
                        {itm?.organization?.name?.split(" ")?.[1]?.[0]}
                      </label>
                    </div>
                    <div className={classNames("flex flex-col gap-1")}>
                      <h2>Evaluation Request</h2>
                      <p>
                        Complete pending evaluation requests from{" "}
                        {itm?.organization?.name}
                        .
                      </p>
                      <span>{moment(itm?.created_at).fromNow()}</span>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <NoContentCard label1="No Notifications" />
          )}
        </div>
      </div>
    </GlobalWrapper>
  );
};

export default NotificationsDropDown;
